import { ISMT_CauTrucDe_Insert_Request } from "../../model/request/de-thi/ISMT_CauTrucDe_Insert_Request";
import { apiClient } from "../apiClient";
export const CAU_TRUC_DE_THI_ENDPOINT = "cau-truc-de-thi";
export const cauTrucDeThiApi = {
  SelectAll: () => apiClient.get(`${CAU_TRUC_DE_THI_ENDPOINT}`),
  Select: () => apiClient.get(`${CAU_TRUC_DE_THI_ENDPOINT}/select`),
  SelectAllVm: () => apiClient.get(`${CAU_TRUC_DE_THI_ENDPOINT}/select-all-vm`),
  SelectForDotTaoDe: (id_mon: number, id_dot_thi: number) =>
    apiClient.get(
      `${CAU_TRUC_DE_THI_ENDPOINT}/select-for-dot-tao-de/${id_mon}/${id_dot_thi}`,
    ),
  SelectKhoCauHoi: (id: number) =>
    apiClient.get(`${CAU_TRUC_DE_THI_ENDPOINT}/kho-cau-hoi/${id}`),
  SelectSection: (id: number) =>
    apiClient.get(`${CAU_TRUC_DE_THI_ENDPOINT}/section-by-id/${id}`),
  SelectById: (id: number) =>
    apiClient.get(`${CAU_TRUC_DE_THI_ENDPOINT}/${id}`),
  Insert: (payload: ISMT_CauTrucDe_Insert_Request) =>
    apiClient.post(`${CAU_TRUC_DE_THI_ENDPOINT}`, payload),
  Update: (payload: ISMT_CauTrucDe_Insert_Request) =>
    apiClient.put(`${CAU_TRUC_DE_THI_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${CAU_TRUC_DE_THI_ENDPOINT}/${id}`),
  ExportExcel: (payload: any) => apiClient.post(`${CAU_TRUC_DE_THI_ENDPOINT}/export-excel`, payload),
  DeleteMultiple: (ids: number[]) =>
    apiClient.put(`${CAU_TRUC_DE_THI_ENDPOINT}/delete-multiple`, ids),
};
